import type { ReactElement } from "react";
import { useIdCopy } from "@hooks/useIdCopy";

export type SideNavRowCopyProps = Partial<
    ReturnType<ReturnType<typeof useIdCopy>["getCopyProps"]>
>;

const SideNavRowCopyTargetWithId = ({
    labelCopyId,
    labelCopyLabel,
    children,
}: {
    labelCopyId: string | number;
    labelCopyLabel?: string;
    children: (copyProps: SideNavRowCopyProps) => ReactElement;
}) => {
    const { getCopyProps } = useIdCopy({ label: labelCopyLabel });

    return children(getCopyProps(labelCopyId));
};

/**
 * Spreads right-click ID copy onto the row target (link or button), above the
 * stretched `::after` hit area, when `labelCopyId` is set and `showDbIds` is on.
 */
export const SideNavRowCopyTarget = ({
    labelCopyId,
    labelCopyLabel,
    children,
}: {
    labelCopyId?: string | number;
    labelCopyLabel?: string;
    children: (copyProps: SideNavRowCopyProps) => ReactElement;
}) => {
    if (labelCopyId === undefined) {
        return children({});
    }

    return (
        <SideNavRowCopyTargetWithId
            labelCopyId={labelCopyId}
            labelCopyLabel={labelCopyLabel}
        >
            {children}
        </SideNavRowCopyTargetWithId>
    );
};
